import PropTypes from 'prop-types';
import React from 'react';

import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';

import StyledInfobox from './infobox.style';

const Infobox = ({
  headline,
  subline,
  copy,
  alignment = 'left',
  wide = false,
  expirationDate,
  ...props
}) => {
  if (expirationDate?.c && new Date(expirationDate?.c) <= new Date()) {
    return null;
  }

  return (
    <StyledInfobox alignment={alignment} wide={wide}>
      <div className="infobox__background" />
      <div className="infobox__content-wrapper">
        <div className="infobox__content">
          {subline && (
            <Headline tag="h4" subline>
              {subline}
            </Headline>
          )}

          {headline && (
            <Headline tag="h3" tertiary className="infobox__headline">
              {headline}
            </Headline>
          )}

          {copy && <MixedCopy html={copy} fullWidth />}
        </div>
      </div>
    </StyledInfobox>
  );
};

Infobox.propTypes = {
  headline: PropTypes.string,
  subline: PropTypes.string,
  copy: PropTypes.string,
  alignment: PropTypes.oneOf(['right', 'left']),
  wide: PropTypes.bool,
  expirationDate: PropTypes.string
};

export default Infobox;
